export const SET_REGROUPEMENTS = 'SET_REGROUPEMENTS'
export const SET_REGROUPEMENTS_LOADING = 'SET_REGROUPEMENTS_LOADING'
export const SET_REGROUPEMENTS_PAGE = 'SET_REGROUPEMENTS_PAGE'
export const UPDATE_REGROUPEMENT = 'UPDATE_REGROUPEMENT'
export const DELETE_REGROUPEMENT = 'DELETE_REGROUPEMENT'
export const SET_CURRENT_REGROUPEMENT = 'SET_CURRENT_REGROUPEMENT'
export const RESET_CURRENT_REGROUPEMENT = 'RESET_CURRENT_REGROUPEMENT'
export const SET_REGROUPEMENT_MASTER_ARTICLE = 'SET_REGROUPEMENT_MASTER_ARTICLE'
export const SET_REGROUPEMENT_ARTICLES = 'SET_REGROUPEMENT_ARTICLES'
export const SET_REGROUPEMENT_ATTRIBUTS = 'SET_REGROUPEMENT_ATTRIBUTS'
export const ADD_REGROUPEMENT_AVAILABLE_ATTRIBUTS = 'ADD_REGROUPEMENT_AVAILABLE_ATTRIBUTS'
export const ADD_REGROUPEMENT_ATTRIBUT = 'ADD_REGROUPEMENT_ATTRIBUT'
export const REMOVE_REGROUPEMENT_ATTRIBUT = 'REMOVE_REGROUPEMENT_ATTRIBUT'
export const SET_REGROUPEMENT_TITLE = 'SET_REGROUPEMENT_TITLE'
export const SET_REGROUPEMENT_CANONICAL_TAG = 'SET_REGROUPEMENT_CANONICAL_TAG'
